// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-181815b4]{display:flex;flex-direction:column;justify-content:center;align-items:center;position:relative}", ""]);
// Exports
module.exports = exports;
